export const accountFilterState = () => ({
  searchKey: '',
  page: 1,
  perPage: 10
});
